const dataDelimiter = '~~';

export { dataDelimiter as default };